import {connect, Dispatch} from '@modifi/redux'
import {aShowDialog, DialogManager} from '@modifi/plugin-dialogs'

import DeleteBeneficialOwnerButton from './DeleteBeneficialOwnerButton'
import {aDelete} from './store'
import DeleteUbo, {DELETE_UBO_DIALOG_NAME} from './dialogs'

DialogManager.addDialog(DELETE_UBO_DIALOG_NAME, DeleteUbo)

const mapStateToProps = null

const mapDispatchToProps = (
  dispatch: Dispatch,
  ownProps: {externalPersonId: string; target: string}
): {onClick: () => void} => ({
  onClick: (): void => {
    const onConfirm = async (): Promise<void> => {
      await dispatch(aDelete(ownProps.externalPersonId) as any)
    }

    dispatch(
      aShowDialog(DELETE_UBO_DIALOG_NAME, {
        onConfirm,
        target: ownProps.target,
        entryType: 'confirm-delete-person',
      })
    )
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(DeleteBeneficialOwnerButton)
